import { Subtitle2Stronger } from "@fluentui/react-components";
import { memo, ReactNode } from "react";
import { useEmptyPlaceholderStyles } from "./styles";

type EmptyPlaceholderProps = {
  text: string;
  icon?: ReactNode;
  className?: string;
  textClassName?: string;
};

export const EmptyPlaceholder = memo(({ text, icon, className, textClassName }: EmptyPlaceholderProps) => {
  const styles = useEmptyPlaceholderStyles();
  return (
    <div className={className ?? styles.container}>
      {icon}
      <Subtitle2Stronger className={textClassName ?? ""}>{text}</Subtitle2Stronger>
    </div>
  );
});
